import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth, AuthStep } from '../hooks/useAuth';
import PhoneForm from '../components/PhoneForm';
import VerifyForm from '../components/VerifyForm';
import ProfileForm from '../components/ProfileForm';
import toast from 'react-hot-toast';
import logoImage from '../assets/logo.avif';

const PhoneAuthPage: React.FC = () => {
  const { redirectUrl } = useLocation().state as {redirectUrl?: string} || {};
  const navigate = useNavigate();
  const { step, error, isLoading, sendOtp, verifyOtp, updateUserProfile } = useAuth({redirectUrl});
  const [phoneNumber, setPhoneNumber] = useState<string>('');
  
  const handleSendOtp = (phone: string) => {
    // 특수문자 제거
    let cleanedPhone = phone.replace(/[^\d]/g, '');
    
    // 010으로 시작하지 않으면 앞에 0 추가
    if (!cleanedPhone.startsWith('010')) {
      if (cleanedPhone.startsWith('10')) {
        cleanedPhone = '0' + cleanedPhone;
      }
    }
    
    setPhoneNumber(cleanedPhone);
    sendOtp(cleanedPhone);
  };

  const handleVerifyOtp = (token: string) => {
    verifyOtp(phoneNumber, token);
  };

  const renderForm = (currentStep: AuthStep) => {
    switch (currentStep) {
      case 'phone':
        return <PhoneForm isLoading={isLoading} sendOtp={handleSendOtp} />;
      case 'verify':
        return <VerifyForm isLoading={isLoading} verifyOtp={handleVerifyOtp} phone={phoneNumber} />;
      case 'name':
        return <ProfileForm isLoading={isLoading} updateUserProfile={updateUserProfile} isEdit={false} />;
    }
  };

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  return (
    <div className="px-4">
      <div className="flex items-end justify-between pt-16 pb-8">
        <img src={logoImage} alt="logo" className="w-50 select-none cursor-pointer" onClick={() => navigate('/')} />
      </div>
      {renderForm(step)}
    </div>
  );
};

export default PhoneAuthPage; 